import * as React from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import JssProvider from 'react-jss/lib/JssProvider';
import { createGenerateClassName } from '@material-ui/core/styles';

const generateClassName = createGenerateClassName({
  dangerouslyUseGlobalCSS: true,
  productionPrefix: '',
});

const OnboardingSteps =  ({current}) => {
  const steps = ['REGISTER', 'CHARITY DETAILS', 'CHARITY PERSON DETAILS', 'CONNECT STRIPE']
  return(
    <JssProvider generateClassName={generateClassName}>
    <Stepper activeStep={current} alternativeLabel>
    {steps.map(label => {
      const labelProps = {};
      return (
        <Step key={label}>
          <StepLabel {...labelProps}>{label}</StepLabel>
        </Step>
      );
    })}
  </Stepper>
  </JssProvider>
);
}
export default  OnboardingSteps;